import { Routes } from "@angular/router";
import { StockStatisticsRoutePaths } from "./stock-statistics-route-paths";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { importProcessResolver } from "./resolvers/import-process.resolver";

export const stockStatisticsRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: StockStatisticsRoutePaths.TREND,
  },
  {
    path: "",
    resolve: {
      translate: loadTranslationResolver([TRANSLATION_PATHS.STOCK.STATISTICS]),
    },
    children: [
      {
        path: StockStatisticsRoutePaths.TREND,
        loadComponent: () => import("./pages/stock-trends/stock-trends.component").then(m => m.StockTrendsComponent),
      },
      {
        path: StockStatisticsRoutePaths.RUN_LIST,
        loadComponent: () => import("./pages/run-list/run-list.component").then(m => m.RunListComponent),
      },
      {
        path: StockStatisticsRoutePaths.VIEW_RUN_LIST,
        loadComponent: () => import("./pages/view-stock-run-list/view-stock-run-list.component").then(m => m.ViewStockRunListComponent),
        resolve: {
          importProcess: importProcessResolver,
        },
      },
      {
        path: StockStatisticsRoutePaths.OVERVIEW,
        loadComponent: () => import("./pages/overview/overview.component").then(m => m.OverviewComponent),
      },
    ],
  },
];
